import clone from "lodash.clone";
import { parseWithWeekday } from '@/lib/dayjs';

function generateUUID() {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line no-mixed-operators,no-bitwise
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

const transformItinerary = (bookingItinerary, origItinerary) => {
  let tmp;
  if (!origItinerary) return [];
  const itinerary = clone(origItinerary);

  for (let i = 0; i < itinerary.length; i++) {
    if (itinerary[i].title) {
      tmp = parseWithWeekday(itinerary[i].title, "ddd D MMM YYYY");
      itinerary[i].title_day = tmp.format("dddd");
      itinerary[i].title_date = tmp.format("D MMM YYYY");
    }
    itinerary[i].types = [];
    if (itinerary[i].data.length > 0) {
      itinerary[i].mainBookingId = itinerary[i].data[0]._id || itinerary[i].data[0].mainBookingId
    }

    // Need unique key added to each sub data element
    for (let k = 0; k < itinerary[i].data.length; k++) {
      if (itinerary[i].data[k].isSafari) {
        itinerary[i].isSafari = true;
      }
      itinerary[i].data[k].unique_key = generateUUID()
      itinerary[i].types.push(itinerary[i].data[k].jsontype)
      // Work out display title
      if (itinerary[i].data[k].jsontype === "flight") {
        itinerary[i].types.push("flight");
        // Split on bracket
        tmp = itinerary[i].data[k].cityfrom.split("(");
        if (tmp.length > 1) {
          itinerary[i].data[k].cityfromdisplay = `${tmp[0].trim()}\n(${tmp[1]}`;
        } else {
          itinerary[i].data[k].cityfromdisplay = itinerary[i].data[k].cityfrom;
        }
        tmp = itinerary[i].data[k].cityto.split("(");
        if (tmp.length > 1) {
          // Title
          itinerary[i].data[k].title = `Flight to ${tmp[0].trim()}`;
          itinerary[i].data[k].citytodisplay = `${tmp[0].trim()}\n(${tmp[1]}`;
        } else {
          itinerary[i].data[k].title = `Flight to ${tmp[0].trim()}`;
          itinerary[i].data[k].citytodisplay = itinerary[i].data[k].cityto;
        }
      }
      if (
        itinerary[i].data[k].jsontype === "insurance" &&
        itinerary[i].data[k].instype === "INSURANCE"
      ) {
        itinerary[i].data[k].title = "Travel Insurance";
      }

      if (
        itinerary[i].data[k].jsontype === "insurance" &&
        itinerary[i].data[k].instype === "INSURANCE AMENDMENT"
      ) {
        itinerary[i].data[k].title = "Insurance Amendment";
      }

      if (
        itinerary[i].data[k].jsontype === "insurance" &&
        itinerary[i].data[k].instype === "OPTIONAL INSURANCE"
      ) {
        itinerary[i].data[k].title = "Optional Insurance";
      }

      if (itinerary[i].data[k].jsontype === "transfer") {
        itinerary[i].types.push("transfer");
        itinerary[i].data[
          k
        ].title = `Transfer from ${itinerary[i].data[k].cityfrom} to ${itinerary[i].data[k].cityto}`;
      }

      if (
        itinerary[i].data[k].jsontype === "own" ||
        itinerary[i].data[k].jsontype === "surf"
      ) {
        itinerary[i].data[k].title = "Own Arrangements";
      }

      if (itinerary[i].data[k].jsontype === "tour") {
        itinerary[i].types.push("tour");
        if (itinerary[i].data[k].tourtype === "CRUISE") {
          itinerary[i].data[
            k
          ].title = `CRUISE from ${itinerary[i].data[k].cityfrom}`;
        } else if (
          itinerary[i].data[k].tourtype === "LOCAL TOUR" ||
          itinerary[i].data[k].tourtype === "ATTRACTION TICKETS" ||
          itinerary[i].data[k].tourtype === "THEATRE TICKETS" ||
          itinerary[i].data[k].tourtype === "SHORE EXCURSION"
        ) {
          itinerary[i].data[
            k
          ].title = `${itinerary[i].data[k].tourtype} in ${itinerary[i].data[k].cityfrom}`;
        } else if (itinerary[i].data[k].tourtype === "ESCORTED TOUR") {
          itinerary[i].data[
            k
          ].title = `Escorted Coach Tour from ${itinerary[i].data[k].cityfrom}`;
        } else if (itinerary[i].data[k].tourtype === "WEDDING PACKAGE") {
          itinerary[i].data[
            k
          ].title = `Wedding Package in ${itinerary[i].data[k].cityfrom}`;
        } else if (
          itinerary[i].data[k].touringHubItem &&
          itinerary[i].data[k].tourhubtype !== "touringhub-main"
        ) {
          // Do nothing
        } else {
          itinerary[i].data[
            k
          ].title = `${itinerary[i].data[k].tourtype} from ${itinerary[i].data[k].cityfrom}`;
        }
        // See if we have essential information
        if (itinerary[i].data[k].holessenfiles) {
          if (itinerary[i].data[k].holessenfiles[0].supplier) {
            itinerary[i].data[k].essential_info =
              itinerary[i].data[k].holessenfiles[0].supplier;
          }
        }

        let imageUrls = itinerary[i].data[k].imageurl;
        if (itinerary[i].data[k].tourtype === "CRUISE") {
          imageUrls = [
            imageUrls && imageUrls["750x750"] ? imageUrls["750x750"] : "",
          ];
        }
        if (imageUrls) {
          if (!Array.isArray(imageUrls)) {
            imageUrls = [imageUrls];
          }
          itinerary[i].data[k].galleryImages = imageUrls.filter((i) =>
            i.endsWith(".jpg")
          );
          itinerary[i].data[k].videos = imageUrls.filter((i) =>
            i.endsWith(".mp4")
          );
        }
        // Check to see if it's a cruise video, most likely - youtubevideo
        if (imageUrls && itinerary[i].data[k].tourtype === "CRUISE") {
          if (!Array.isArray(imageUrls)) {
            imageUrls = [imageUrls];
          }
          const youTubeVideos = imageUrls.filter((i) => i.includes("youtu"));
          const isImage = imageUrls;
          if (isImage && youTubeVideos.length < 1) {
            itinerary[i].data[k].showPlay = false;
          } else {
            itinerary[i].data[k].showPlay = true;
          }
          itinerary[i].data[k].videos = youTubeVideos;
        }
        // If no imageurls for cruise tour then set default img
        if (!imageUrls && itinerary[i].data[k].tourtype === "CRUISE") {
          const defaultImage =
            "https://cdn.trailfinders.com/mulck2xojj_logo-cruise-excellence-reverse.png";
          itinerary[i].data[k].imageurl = defaultImage;
          itinerary[i].data[k].isDefaultImg = true;
        }
      }

      if (itinerary[i].data[k].jsontype === "rail") {
        itinerary[i].data[
          k
        ].title = `Rail from ${itinerary[i].data[k].cityfrom}`;
        tmp = itinerary[i].data[k].cityfrom.split(",");
        itinerary[i].data[k].cityfromsimple = tmp[0].trim();
        tmp = itinerary[i].data[k].cityto.split(",");
        itinerary[i].data[k].citytosimple = tmp[0].trim();
      }
      if (itinerary[i].data[k].jsontype === "coach") {
        itinerary[i].data[
          k
        ].title = `Bus from ${itinerary[i].data[k].cityfrom}`;
        tmp = itinerary[i].data[k].cityfrom.split(",");
        itinerary[i].data[k].cityfromsimple = tmp[0].trim();
        tmp = itinerary[i].data[k].cityto.split(",");
        itinerary[i].data[k].citytosimple = tmp[0].trim();
      }
      if (itinerary[i].data[k].jsontype === "hotel") {
        itinerary[i].types.push("hotel");
        tmp = itinerary[i].data[k].city.split("(");
        itinerary[i].data[k].title = `Hotel in ${tmp[0].trim()}`;
        if (itinerary[i].data[k].addresslines.length === 5) {
          // eslint-disable-next-line prefer-destructuring
          itinerary[i].data[k].telephone = itinerary[i].data[k].addresslines[4];
          itinerary[i].data[
            k
          ].address = `${itinerary[i].data[k].addresslines[0]} ${itinerary[i].data[k].addresslines[1]} ${itinerary[i].data[k].addresslines[2]} ${itinerary[i].data[k].addresslines[3]}`;
        }
      }
      if (itinerary[i].data[k].jsontype === "vehicle") {
        if (itinerary[i].data[k].vehicletype === "MOTORHOME RENTAL") {
          itinerary[i].data[
            k
          ].title = `Motorhome From ${itinerary[i].data[k].pickupcity}`;
        } else if (itinerary[i].data[k].pickupcity) {
          tmp = itinerary[i].data[k].pickupcity.split(",");
          itinerary[i].data[k].title = `Car Hire from ${tmp[0].trim()}`;
        } else {
          itinerary[i].data[k].title = "Car Hire";
        }
      }

      // If we are checkin then add details to previous item
      if (itinerary[i].data[k].jsontype === "checkin") {
        if (bookingItinerary.includesPTF) {
          itinerary[i].data[
            k
          ].checkin = `Departing from ${itinerary[i].data[k].airport}, 
          Terminal ${itinerary[i].data[k].terminal}\nMinimum Check in requirement: ${itinerary[i].data[k].time} before departure`;
        } else {
          let previousFlightIndex = k - 1;
          while (previousFlightIndex >= 0) {
            if (itinerary[i].data[previousFlightIndex].jsontype === "flight") {
              itinerary[i].data[
                previousFlightIndex
              ].checkin = `Departing from ${itinerary[i].data[k].airport},
              Terminal ${itinerary[i].data[k].terminal}\nMinimum Check in requirement: ${itinerary[i].data[k].time} before departure`;
              break;
            }
            previousFlightIndex--;
          }
        }
      }
    }
  }
  return itinerary;
};

const addItineraryReturnDeparture = (itinerary) => {
  const cardData = {};
  for (let i = 0; i < itinerary.length; i++) {
    for (let k = 0; k < itinerary[i].data.length; k++) {
      if (
        itinerary[i].data[k].jsontype !== "insurance" &&
        itinerary[i].data[k].statusonrecord !== "CANCELLED" &&
        itinerary[i].data[k].statusonrecord !== "UNABLE TO CONFIRM"
      ) {
        if (itinerary[i].data[k].deptime) {
          cardData.dep_time = itinerary[i].data[k].deptime;
        }
        if (itinerary[i].title_date) {
          const tmp = parseWithWeekday(itinerary[i].title_date, "D MMM YYYY");
          cardData.dep_date = tmp.format("ddd Do MMMM YYYY");
        }
        if (itinerary[i].data[k].cityfrom) {
          cardData.dep_place = itinerary[i].data[k].cityfrom;
        }
        return cardData;
      }
    }
  }
};

const getFirstFlightDepCity = (itinerary) => {
  for (let i = 0; i < itinerary.length; i++) {
    for (let k = 0; k < itinerary[i].data.length; k++) {
      if (itinerary[i].data[k].jsontype === "flight") {
        return itinerary[i].data[k].cityfrom.split(" ")[0];
      }
    }
  }
};

const getPTFSuppliers = (itinerary) => {
  const _ret = [];
  for (let i = 0; i < itinerary.length; i++) {
    for (let ii = 0; ii < itinerary[i].data.length; ii++) {
      if (itinerary[i].data[ii].tourtype === "PRIVATE TOUR") {
        for (
          let y = 0;
          y <= itinerary[i].data[ii].holessenfiles.length - 1;
          y++
        ) {
          _ret.push(itinerary[i].data[ii].holessenfiles[y].suppliername);
        }
      }
    }
  }

  return _ret;
};

const itineraryTransformForView = (itinerary, notes, additionaldocs) => {
  const outItems = [];
  let insuranceItem;
  let insuranceOptionalItem;
  let insuranceTopupAmountPerPerson;
  let insuranceTopupItem;
  const insuranceAmendmentItem = [];
  let notesFiltered;
  const cancelled = [];

  itinerary.forEach((itItem) => {
    let day;
    let dayCancelled;
    if (itItem && itItem.data && itItem.data.length) {
      day = {
        title_day: itItem.title_day,
        title_date: itItem.title_date,
        types: itItem.types,
        tourDay: itItem.tourDay,
        mainBookingId: itItem.mainBookingId,
        data: [],
      };
      const bookableServ = itItem.data.find(serv => !serv.hasOtherTfArrangements && serv.mainBookingId)
      if (bookableServ && bookableServ.mainBookingId) {
        day.mainBookingId = bookableServ.mainBookingId
        if (itItem.touringHubDayCounts && itItem.touringHubDayCounts[day.mainBookingId]) {
          day.tourDay = itItem.touringHubDayCounts[day.mainBookingId]
        }
      }
      dayCancelled = {
        title_day: itItem.title_day,
        title_date: itItem.title_date,
        types: itItem.types,
        data: [],
      };

      itItem.data.forEach((dataItem) => {
        if (
          !dataItem.title &&
          dataItem.instype &&
          dataItem.instype.includes("ANNUAL")
        ) {
          dataItem.title = dataItem.instype;
        }
        if (dataItem.title) {
          if (
            dataItem.status === "CANCELLED" ||
            dataItem.status === "UNABLE TO CONFIRM"
          ) {
            dayCancelled.data.push(dataItem);
          } else {
            if (dataItem.jsontype === "insurance" && 
              (!dataItem.insurancefor || !dataItem.insurancefor.includes('Increased cancellation')) &&
            (
              dataItem.instype === "INSURANCE" ||
              dataItem.instype === "ANNUAL WORLDWIDE INSURANCE" ||
              dataItem.instype === "ANNUAL WORLDWIDE INSURANCE (incl. cruises)"
            )) {
              insuranceItem = dataItem;
            } else if (
              dataItem.jsontype === "insurance" &&
              dataItem.insurancefor &&
              dataItem.insurancefor.includes('Increased cancellation')
            ) {
              insuranceTopupItem = dataItem
            }
            
            else if (
              dataItem.jsontype === "insurance" &&
              dataItem.instype === "INSURANCE AMENDMENT"
            ) {
              insuranceAmendmentItem.push(dataItem);
            } else if (
              dataItem.jsontype === "insurance" &&
              dataItem.instype === "OPTIONAL INSURANCE"
            ) {
              insuranceOptionalItem = dataItem;
            } else {
              day.data.push(dataItem);
            }
            // topup insurance check
              if (dataItem.insurancefor && dataItem.insurancefor.includes('Increased cancellation') && dataItem.insuranceaddcoverpp && !insuranceTopupAmountPerPerson) { 
                // top-up cancellation cover amount. Will come through as a string including the currency symbol. We only want the digits
                let topupInsuranceDigits = dataItem.insuranceaddcoverpp.replace(/[^0-9]/, '')
                if (topupInsuranceDigits && Number(topupInsuranceDigits)) { 
                  insuranceTopupAmountPerPerson = Number(topupInsuranceDigits)
                }
              }
          }
        }
        if (dataItem.isSafari) {
          day.isSafari = true;
        }
      })
    }
    if (day && day.data.length) {
      outItems.push(day);
    }
    if (dayCancelled && dayCancelled.data.length) {
      cancelled.push(dayCancelled);
    }
  });
  // filter empty notes out
  // must have description or fnotes array
  if (Array.isArray(notes)) {
    notesFiltered = notes.filter(
      (note) =>
        note.description ||
        (note.fnotes && note.fnotes[0]) ||
        note.jsontype === "additionalsupdocs"
    );
  }
  return {
    items: outItems,
    insuranceItem,
    insuranceAmendmentItem,
    insuranceOptionalItem,
    notes: notesFiltered,
    additionaldocs,
    cancelled,
    insuranceTopupAmountPerPerson,
    insuranceTopupItem,
  };
};

export {
  transformItinerary,
  addItineraryReturnDeparture,
  getFirstFlightDepCity,
  itineraryTransformForView,
  getPTFSuppliers,
};
